
import React from 'react';
import PropTypes from 'prop-types';

import FirstInstallImg from '../InstallImages/PitchedRoofImages/FirstInstallImg';
import PitchedRoofImg5 from '../InstallImages/PitchedRoofImages/PitchedRoofImg5';
import ThirdInstallImg from '../InstallImages/PitchedRoofImages/ThirdInstallImg';
import FourthInstallImg from '../InstallImages/PitchedRoofImages/FourthInstallImg';

import '../saleslogic.css';
import '../../../../../../grid.css';

const PitchedRoof = (props) => {
    const { firstName } = props;

    // images are 952 x 406

    return (
        <div className="row" >
            <h1 className="arrayType">Pitched Roof Installation</h1>
            <div className="row installTextGroup">
                <p className="col span-1-of-3 installText">
                    {firstName}, Solvana takes great pride in installing PV solar-generating systems to the highest standards, and yours will be no different. We use all black PV solar modules, racking, and flashing to keep your array sleek. We even hide conduit and wire runs from your view whenever possible. When we finish completing your project, you will be glad you chose Solvana to design, engineer, and install your PV solar-generating system. {firstName}, take a look at this picture and notice how there is no conduit connecting the module planes and subarrays, or anywhere else for that matter because they are all hidden! Next time you are driving around town, take a moment to look for them, as most installers do not hide conduit as we do. The result of Solvana’s careful choices of equipment is the most attractive looking PV solar-generating system you will ever see.
                </p>
                <p className="col span-2-of-3 installPics"><FirstInstallImg /></p>
            </div>
            <div className="row installTextGroup">
                <p className="col span-2-of-3 installPics"><ThirdInstallImg /></p>
                <p className="col span-1-of-3 installText"> It is no secret how we did it! Whenever possible, Solvana uses Pass-Through Boxes (5-total on the system shown here) to keep conduit and wire hidden from view by passing them into the attic through flashing hardware similar to the ones that your rooftop plumbing pipes pass through. Pass-Through Boxes ensure you will not have any ugly conduit wrapped over the edge of your roof. The point is that we care, and our motto is, “if we would not install it that way on our roofs, then we will not install it that way on yours.” Other companies run ugly conduit all over your roof to save them time and lower their costs with little regard as to how it looks. Check out a few examples of our work. {firstName}, please keep in mind that Pass-Through-Boxes is only one of the ways we leave our indelible mark on our first-rate installations!</p>
            </div>
            <div className="row installTextGroup">
                <p className="col span-1-of-3">
                    <blockquote>
                        <p>Very professional and knowledgeable bunch of guys, it was a pleasure to work with them. Would recommend every time !!!
                        </p>
                    </blockquote>
                    <footer>
                        <cite>
                            - Slawek H. Readington Twp., NJ
                        </cite>
                    </footer>
                </p>
                <p className="col span-2-of-3 installPics">
                    <PitchedRoofImg5 />
                </p>
            </div>
            <div className="row installTextGroup">
                <p className="col span-2-of-3 installPics"><FourthInstallImg /></p>
                <p className="col span-1-of-3">
                    <blockquote>
                        <p>Ric and Bob were great to work with through the whole process! I did my research since it was my first solar project and I felt Solvana had the most knowledge. I will be using them on my other properties.
                        </p>
                    </blockquote>
                    <footer>
                        <cite>
                            - Business Owner Michael B. Toms River, NJ
                        </cite>
                    </footer>
                </p>
            </div>
        </div>
    );
};

PitchedRoof.propTypes = {
    firstName: PropTypes.string.isRequired,
};

export default PitchedRoof;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/PitchedRoof/PitchedRoof.js